/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from "moment";
import {
  AllModules,
  AllVendors,
  Brand,
  Category,
  GoodsRequests,
  GoodsWarehouse,
  Inventory,
  ProductVariants,
  MasterProduct,
  LowStockList,
  LowStockLists,
  PaymentsToVendors,
  PendingCertificates,
  TechnicalDetails,
  UMart,
  UTrade,
  Vendors,
} from "./constants";
import axios from "axios";
const Method = {
  convertDateToDDMMYYYY: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY ");
  },
  getTodayDate: (format: string) => {
    return moment(new Date()).local().format(format);
  },
  convertDateToFormat: (date: any, format: string) => {
    return moment(date).local().format(format);
  },
  convertDateToDDMMYYYYHHMM: (date: string, separator?: string) => {
    if (!separator) return moment(date).local().format("DD/MM/YYYY hh:mm ");
    else {
      let format = "DD/MM/YYYY [" + separator + "]  hh:mm";
      return moment(date).local().format(format);
    }
  },
  convertDateToDDMMYYYYHHMMAMPM: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY hh:mm A");
  },
  convertDateToDDMMYYYYHOURS: (date: string) => {
    return moment(date).local().format("DD/MM/YYYY [,] HH:mm ");
  },
  checkisSameOrAfter: (date1: string, date2: string) => {
    return moment(date2).isSameOrAfter(date1);
  },
  dayDifference: (date1: any, date2: any) => {
    return moment(date2).diff(date1, "days");
  },
  convertDateToDDMMYYYYHHMMAMPMWithSeperator: (
    date: string,
    seperator?: string
  ) => {
    if (!seperator) return moment(date).local().format("DD/MM/YYYY hh:mm A");
    else {
      // eslint-disable-next-line prefer-const
      let format = "DD/MM/YYYY [" + seperator + "]  hh:mm A";
      return moment(date).local().format(format);
    }
  },
  getNameCharacter: (name: string) => {
    if (!name || name.length === 0) return "";
    name = name.toUpperCase();
    const [firstName, lastName] = name.split(" ");
    let chars = "";
    if (firstName) chars += firstName[0];
    if (lastName) chars += lastName[0];
    return chars;
  },
  getGeneralizedAmount: (amount: number) => {
    if (amount === null || amount === undefined || isNaN(amount)) return "0";
  
    if (amount >= 1_000_000_000) {
      return `${(amount / 1_000_000_000).toFixed(1)}B`;
    }
  
    if (amount >= 1_000_000) {
      return `${(amount / 1_000_000).toFixed(1)}M`;
    }
  
    if (amount >= 1_000) {
      return `${(amount / 1_000).toFixed(1)}K`;
    }
  
    return amount.toLocaleString("en-US");
  },
  hasPermission: (
    module: number,
    permission: number,
    currentUser: any
  ): boolean => {
    if (currentUser?.role && currentUser?.role?.length) {
      return true;
    } else {
      if (!currentUser?.roleAndPermission?.permissions) return false;
      const hasAllModules = currentUser?.roleAndPermission?.permissions?.some(
        (item: any) => item?.module === AllModules
      );
      if (hasAllModules) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const allModulePermissions =
          currentUser?.roleAndPermission?.permissions?.find(
            (item: any) => item?.module === AllModules
          );
        return true;
      }
      const modulePermissions =
        currentUser?.roleAndPermission?.permissions.find(
          (item: any) => item.module === module
        );
      if (!modulePermissions?.permissions?.length) {
        return false;
      }
      return modulePermissions.permissions.includes(permission);
    }
  },
  hasModulePermission: (module: number, currentUser: any) => {
    const allModules: any = [
      AllModules,
      Vendors,
      Inventory,
      GoodsRequests,
      AllVendors,
      PendingCertificates,
      PaymentsToVendors,
      UTrade,
      UMart,
      LowStockList,
      GoodsWarehouse,
      LowStockLists,
      Category,
      Brand,
      TechnicalDetails,
      ProductVariants,
      MasterProduct,
    ];
    // const permissionModules =
    //   currentUser?.roleAndPermission &&
    //   currentUser?.roleAndPermission.permissions.length > 0
    //     ? currentUser?.roleAndPermission.permissions.permissions.includes(AllModules)
    //       ? allModules
    //       : currentUser.roleAndPermission.permissions.map(
    //           (item: any) => item.module
    //         )
    //     : allModules;
    const permissionModules =
      currentUser?.roleAndPermission &&
      currentUser?.roleAndPermission.permissions.length > 0
        ? currentUser?.roleAndPermission?.permissions?.some(
            (item: any) => item?.module === AllModules
          )
          ? allModules
          : currentUser?.roleAndPermission?.permissions?.map(
              (item: any) => item.module
            )
        : allModules;
    return permissionModules.includes(module);
  },
  getYear: (date: string) => {
    return moment(date).format("YYYY");
  },
  getMonth: (date: string) => {
    return moment(date).format("MM");
  },
  formatCurrency: (currency: any) => {
    // const value = new Number(currency).toFixed(2);
    // const val = new Intl.NumberFormat('en-IN').format(+value);
    // return val;
    return currency.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3,
    });
  },
  updateUserLogs: async (
    data: any,
    moduleName: any,
    currentUser: any,
    actionType: any
  ) => {
    const res = await axios.post(
      // "http://dev.admin.utrade.imperoserver.in/logs",
      // "http://stagging.admin.utrade.imperoserver.in/logs",
      "https://admin.utrade.tz/logs",
      // "https://admin.utrade.tz/logs",
      // "http://admin.prod.utrade.tz/logs",
      {
        data: data,
        module: moduleName,
        user: {
          name: currentUser?.name,
          email: currentUser?.email,
          userType: currentUser?.userType,
        },
        type: actionType,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },
  getUserLogs: async (moduleName: any, date: any) => {
    const res = await axios.get(
      // "http://dev.admin.utrade.imperoserver.in/read-logs",
      // "http://stagging.admin.utrade.imperoserver.in/read-logs",
      "https://admin.utrade.tz/read-logs",
      // "https://admin.utrade.tz/read-logs",
      // "http://admin.prod.utrade.tz/read-logs",
      {
        params: {
          module: moduleName,
          date: date,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  },
  currentLocalDateTime: () => {
    return moment().format();
  },
  checkIsBefore: (date1: string, date2: string) => {
    return moment(date2).isBefore(date1);
  },
  compareComplexObjects: (oldObj: any, newObj: any) => {
    const changes: { oldValues: any[]; newValues: any[] } = {
      oldValues: [],
      newValues: [],
    };

    function deepCompare(oldVal: any, newVal: any, path: string = "") {
      if (oldVal === undefined && newVal !== undefined) {
        // Property added
        changes.oldValues.push({ path, value: null });
        changes.newValues.push({ path, value: newVal });
        return;
      }

      if (oldVal !== undefined && newVal === undefined) {
        // Property removed
        changes.oldValues.push({ path, value: oldVal });
        changes.newValues.push({ path, value: null });
        return;
      }

      if (
        typeof oldVal === "object" &&
        oldVal !== null &&
        typeof newVal === "object" &&
        newVal !== null
      ) {
        if (Array.isArray(oldVal) && Array.isArray(newVal)) {
          // Compare arrays using max length
          for (let i = 0; i < Math.max(oldVal.length, newVal.length); i++) {
            deepCompare(oldVal[i], newVal[i], `${path}`);
          }
        } else {
          // Compare object properties
          const allKeys = new Set([
            ...Object.keys(oldVal || {}),
            ...Object.keys(newVal || {}),
          ]);
          allKeys.forEach((key) =>
            deepCompare(
              oldVal?.[key],
              newVal?.[key],
              path ? `${path}.${key}` : key
            )
          );
        }
      } else if (oldVal !== newVal) {
        // Direct value change
        changes.oldValues.push({ path, value: oldVal });
        changes.newValues.push({ path, value: newVal });
      }
    }

    deepCompare(oldObj, newObj);
    return changes;
  },
  convertToString: (value: any) => {
    if (!value) return "";
    return value.toString();
  },
  compareCombination: (oldData: any, newData: any) => {
    const changes: any[] = [];
    const oldMap = new Map(oldData.map((item: any) => [item?._id, item]));
    const newMap = new Map(newData.map((item: any) => [item?._id, item]));

    const fieldsToCompare = [
      "cartoonDimenisionH",
      "cartoonDimenisionL",
      "cartoonDimenisionW",
      "pieceDimenisionH",
      "pieceDimenisionL",
      "pieceDimenisionW",
      "pieceWeight",
      "piecePrice",
      "pieceDiscountPrice",
      "pieceDiscount",
      "cartoonWeight",
      "cartoonPrice",
      "cartoonDiscountPrice",
      "cartoonDiscount",
      "dozenDimenisionH",
      "dozenDimenisionL",
      "dozenDimenisionW",
      "dozenWeight",
      "dozenPrice",
      "dozenDiscountPrice",
      "dozenDiscount",
      "cartoonDozens",
      "cartoonPieces",
      "cartoonQuantities",
      "dozenQuantities",
      "pieceQuantities",
      "piecesDozens",
    ];

    oldData.forEach((item: any, index: number) => {
      const newItem: any = newMap.get(item._id);
      if (newItem) {
        const dataChanges: any[] = [];

        fieldsToCompare.forEach((field) => {
          if (
            field === "cartoonQuantities" ||
            field === "dozenQuantities" ||
            field === "pieceQuantities"
          ) {
            if (
              JSON.stringify(newItem.dimensions?.[field]) !==
              JSON.stringify(item?.dimensions?.[field])
            ) {
              dataChanges.push({
                updatedField: field,
                old: "",
                new: newItem.dimensions?.[field],
                operationType: "updated",
              });
            }
          } else {
            if (
              Method.convertToString(newItem.dimensions?.[field]) !==
              Method.convertToString(item.dimensions?.[field])
            ) {
              dataChanges.push({
                updatedField: field,
                old: item.dimensions?.[field],
                new: newItem.dimensions?.[field],
                operationType: "updated",
              });
            }
          }
        });

        if (
          JSON.stringify(newItem.dimensions?.images) !==
          JSON.stringify(item.dimensions?.images)
        ) {
          dataChanges.push({
            updatedField: "Images",
            operationType: "updated",
          });
        }

        if (dataChanges.length) {
          changes.push({ title: item.title, _id: item._id, data: dataChanges });
        }
      } else {
        changes.push({
          title: item.title,
          _id: item._id,
          operation: "deleted",
        });
      }
      item?.dimensions?.product.forEach((prodVal: any, prodIndex: number) => {
        if (newData[index]) {
          const newProd = newData[index].dimensions.product.find(
            (temp: any) => temp.id == prodVal.id
          );
          if (newProd.isChecked !== prodVal.isChecked) {
            changes.push({
              productTitle: item?.title || "",
              title: newProd.value,
              operation: newProd.isChecked ? "Added" : "Removed",
            });
          }
        }
      });
    });

    newData.forEach((item: any) => {
      if (!oldMap.has(item._id)) {
        changes.push({ title: item.title, _id: item._id, operation: "added" });
      }
    });

    return changes;
  },
  compareSearchTags: (oldData: any, newData: any) => {
    if (oldData.length !== newData.length) {
      return {
        data: newData?.map((item: any) => item.value),
        isChanged: true,
      };
    }
    const tagSet = new Set<String>();
    newData.forEach((item: any) => {
      tagSet.add(item?.value);
    });
    oldData.forEach((item: any) => {
      tagSet.add(item?.value);
    });
    if (tagSet.size === newData.length) {
      return {
        data: [],
        isChanged: false,
      };
    }
    return {
      data: newData?.map((item: any) => item.value),
      isChanged: true,
    };
  },
  calculateTax: (
    beforeTaxAmount: number,
    orderedQuantity: number,
    unitPrice: number,
    mVariantObj: any
  ) => {
    return (
      beforeTaxAmount -
      orderedQuantity * (unitPrice / (1 + mVariantObj.productTax / 100))
    );
  },
  replaceSpace: (val: string) => {
    return val.replace(/\s*\)\s*/g, ")");
  },
  populateMissingDates: (dataObject: any, startDate?: any, endDate?: any) => {
    dataObject = dataObject.sort((a: any, b: any) =>
      a.date.localeCompare(b.date)
    );
    let lowestIndex = 0; // Initialize with the first index as the lowest
    let lowestDate = dataObject[0].date; // Initialize with the first date as the lowest
    let highestIndex = 0; // Initialize with the first index as the highest
    let highestDate = dataObject[0].date; // Initialize with the first date as the highest
    for (let i = 1; i < dataObject.length; i++) {
      if (dataObject[i].date < lowestDate) {
        lowestIndex = i;
        lowestDate = dataObject[i].date;
      }
      if (dataObject[i].date > highestDate) {
        highestIndex = i;
        highestDate = dataObject[i].date;
      }
    }
    let temp = [...dataObject];
    const allDates = Array.from(new Set(temp.map((entry: any) => entry.date)));
    // Get the unique months from the dataObject
    const uniqueMonths = Array.from(
      new Set(allDates.map((date: any) => date.slice(0, 7)))
    );
    // Populate missing dates for each month in the dataObject with zeros
    uniqueMonths.forEach((month) => {
      const monthDates = allDates.filter((date: any) => date.startsWith(month));
      let Start = moment(lowestDate).format("DD");
      let end = moment(highestDate).format("DD");
      for (let i = parseInt(startDate); i <= parseInt(endDate); i++) {
        let monthString = "";
        switch (parseInt(month.slice(5, 7))) {
          case 1:
            monthString = "Jan";
            break;
          case 2:
            monthString = "Feb";
            break;
          case 3:
            monthString = "Mar";
            break;
          case 4:
            monthString = "Apr";
            break;
          case 5:
            monthString = "May";
            break;
          case 6:
            monthString = "Jun";
            break;
          case 7:
            monthString = "July";
            break;
          case 8:
            monthString = "Aug";
            break;
          case 9:
            monthString = "Sep";
            break;
          case 10:
            monthString = "Oct";
            break;
          case 11:
            monthString = "Nov";
            break;
          case 12:
            monthString = "Dec";
            break;
        }
        const day = i < 10 ? `0${i}` : `${i}`;
        const date = `${month}-${day}`;
        const dateString = `${monthString} ${day}`;
        if (!monthDates.includes(date)) {
          temp.push({
            date: date,
            totalSales: 0,
            totalShipments: 0,
            fullDate: dateString,
            customers: 0,
            sellers: 0,
          });
        } else {
          const existingEntryIndex = temp.findIndex(
            (entry: any) => entry.date == date
          );
          if (existingEntryIndex !== -1) {
            // Add fullDate if it's not already present
            if (!temp[existingEntryIndex].fullDate) {
              temp[existingEntryIndex].fullDate = dateString;
            }
          }
        }
      }
    });
    // Sort dataObject based on dates
    return temp.sort((a: any, b: any) => a.date.localeCompare(b.date));
  },
  formatQuantityDisplay: (type: number, count: number) => {
    switch (type) {
      case 1:
        return `${count} CWD`;
      case 2:
        return `${count} DZN`;
      case 3:
        return `${count} PCS`;
      case 4:
        return `${count} CWP`;
      default:
        return "";
    }
  },
  convertNotificationDate: (date: string) => {
    return moment(date).local().fromNow();
  },
};

export default Method;
